export var createAddSilentConnection = function createAddSilentConnection(createNativeGainNode) {
  return function (nativeContext, nativeAudioScheduledSourceNode) {
    var nativeGainNode = createNativeGainNode(nativeContext, {
      channelCount: 1,
      channelCountMode: 'explicit',
      channelInterpretation: 'discrete',
      gain: 0
    });
    nativeAudioScheduledSourceNode.connect(nativeGainNode).connect(nativeContext.destination);

    var disconnect = function disconnect() {
      nativeAudioScheduledSourceNode.removeEventListener('ended', disconnect);
      nativeAudioScheduledSourceNode.disconnect(nativeGainNode);
      nativeGainNode.disconnect();
    };

    nativeAudioScheduledSourceNode.addEventListener('ended', disconnect);
  };
};